import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Footer from 'components/Footer/Footer';
import './style.css';
// import StaticBanner from 'components/Banner/StaticBanner';


import Button from 'react-bootstrap/Button';
import { Image, Container, Row, Col } from 'react-bootstrap';
//import eventBanner from "Assets/internationalpk/ipk2021_Branding.jpeg";
import eventBanner from "Assets/internationalpk/sean_rules_2.png";

// import { getQueryString } from "utils/Helper";

import storytellingMadeEasyImg from "Assets/internationalpk/storytelling_made_easy_2021.png";
import tellUsWhatYouLoveImg from "Assets/internationalpk/tell_us_what_you_love_2021.jpeg";
// import ipkMapImg from "Assets/internationalpk/ipk2021_map.jpeg";
import ipkLoveImg from "Assets/internationalpk/ipk2021_love.jpeg";

//import timetable_1 from "Assets/internationalpk/timetable_1.jpeg";
//import timetable_2 from "Assets/internationalpk/timetable_2.jpeg";
import timetable_1 from "Assets/internationalpk/Timetable 3up 2 columns.001 (1).jpeg";
import timetable_2 from "Assets/internationalpk/Timetable 3up 2 columns.002 (1).jpeg";


//import timetable_3 from "Assets/Timetable 3up.003.jpeg";
//import timetable_4 from "Assets/Timetable 3up.004.jpeg";

import home from 'Assets/home.svg';

import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';

import UserContext from 'store/UserContext';

//const signup_link = "https://bit.ly/International_pechakucha_day_2021_zoom_registration";
const signup_link = "https://www.youtube.com/c/PechakuchaOrg/featured";
const download_ipk_images_link = "https://bit.ly/international_pechakucha_day_2021_logos";

class InternationalPk extends Component {
    static contextType = UserContext;
    constructor(props) {
      super(props);
      
      /*
      this.supported_language_abbreviations = new Set();
      this.supported_language_abbreviations.add('en-US');
      this.supported_language_abbreviations.add('ja-JP');
      */
      
      this.pageText = {
        pkmaker_button: {
          'en-US': 'Tell us what you LOVE',
          'ja-JP': 'あなたのLOVEについてシェア'
        },
        signup_now_button: {
          'en-US': 'Sign up now for #ipk2021',
          'ja-JP': '参加登録はこちら #ipk2021'
        },
        intro: {
          'en-US': <span>
            February 20th is PechaKucha’s birthday and our first big initiative of the year: <strong>International PechaKucha Day 2021</strong> - a record-setting, 24-hour, online-around-the-world event, with PechaKucha Cities participating in all 24 time zones, each broadcasting their local creativity to the world!
            We invite you to join this special global event! <strong>#ipk2021</strong>!
          </span>,
          'ja-JP': <span>
            2月20日は、PechaKuchaの誕生日! ということで、今年最初で最大のイベント’<strong>International PechaKucha Day 2021</strong>’ を開催致します! 世界を24のタイムゾーンに分け、PechaKuchaの世界各都市を繋ぎます! 各都市のクリエイティビティを世界へ発信する、という24時間かけて世界一周するという壮大なオンラインイベントです。ぜひ、この特別なイベントに、皆さんご参加ください！ハッシュタグは、<strong>#ipk2021</strong>!
          </span>
        },
        theme_love: {
          'en-US': <span>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>Theme: LOVE</span><br/>
                We all agree, wherever you are, what the world needs now is <span style={{ color: "red" }}>LOVE</span>!<br/>
                        Even in these tough times, there is still much to LOVE in the world.
                        So for this year's International PechaKucha Day, we’ll be traveling around the world, hearing from lovely presenters in our global network of 1256 cities.
                        We’re also inviting ANYONE to make 20x 20 or a 10x10 PK on PechaKucha.com, share on things they LOVE, and we’ll play some of the best throughout the 24-hour broadcast.
                        Everyone can participate!</span>,
          'ja-JP': <span>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>テーマ : LOVE</span><br/>
皆さんが世界中どこにいても、きっと共感いただけると思います。今、世界が必要なのは、<span style={{ color: "red" }}>LOVE</span>!<br/>
この困難な中にあっても、たくさんのLOVEが世界には溢れています。そこで、今年のInternational PechaKucha Dayでは、世界の皆さんと繋がり、世界1256都市のグローバルネットワークから、素敵なプレゼンターの皆さんに参加頂く予定です。さらに、今年はより多くの方々にPechaKucha.comプラットフォームから、参加頂けるチャンスがあります！20x 20や10x10 のPechaKuchaプレゼンテーション形式で、皆さんのLOVEなモノ・コトを、ぜひシェアしてください。投稿頂いたプレゼンテーションの中から、厳選されたプレゼンテーションのいくつかを、イベント当日にシェアさせて頂く予定です。ぜひ、あなたのLOVEを世界に広げてください！
</span>
        },
        when_where: {
          'en-US': <span>
                        <span style={{ fontWeight: "bold", fontSize: "larger" }}>When:</span><br/>
                        20th February - PechaKucha's Birthday! It’s a Saturday so we hope you will tune in for any or all of the 24-Live Stream!<br/>
                        <br/>
                        <span style={{ fontWeight: "bold", fontSize: "larger" }}>Where:</span><br/>
                        We're connecting via Zoom with PechaKucha City organizers from around the world, who will each curate a few presenters for their local time zone.
                        We'll broadcast all the presentations to the world via Webinar and Youtube starting at 12 noon Tokyo on 20th February and finishing at 12 noon the following day.<br/>
          </span>,
          'ja-JP': <span>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>開催日時:</span><br/>
          PechaKuchaの誕生日、2月20日(土)です！週末土曜日開催ですので、ぜひ、ご都合のいいタイミングに、この24時間ライブストリーミングに参加ください！<br/>
          <br/>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>開催場所:</span><br/>
          Zoomを使って、世界中のPechaKucha 都市の主催者とリレー形式で繋がる予定です。各都市のイベント主催者が、割り当てられたタイムスロット内で、数人のプレゼンターをキュレートします。 2月20日の東京時間の正午からスタートし、翌日の正午まで、すべてのプレゼンテーションをウェビナーとユーチューブで世界中に生配信します。<br/>
          </span>
        },
        participate: {
          'en-US': <span>
                        <span style={{ fontWeight: "bold", fontSize: "larger" }}>How to participate:</span><br/>
                        <p style={{ marginLeft: "10px" }}>
                        1. <strong>Register NOW</strong> for the Zoom Webinar and tune in anytime to the #ipk2020 Livestream on Feb 20th.<br/>
                        2. <strong>Create a 20x20 or 10x10 PK</strong> presentation and tag it with <strong>#ipk2021</strong>.
                        We'll feature some of the best throughout the Livestream! <Link to="/pkcreate">Start PK Creating NOW!</Link><br/>
                        3. <strong>Reach out</strong> to your local PechaKucha organizer and nominate yourself to be a presenter.
                        We can help connect you too! Contact us using the handy 'Support' button in the lower right of your screen.<br/>
                        </p>
          </span>,
          'ja-JP': <span>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>参加方法:</span><br/>
          <p style={{ marginLeft: "10px" }}>
          1. <strong>視聴者として参加 !</strong>  - 今すぐズームウェビナーに登録して、2月20日の＃ipk2020ライブストリームにいつでも参加してください。<br/>
          2. <strong>プレゼンテーションを事前投稿 !</strong> - 20枚x20秒、10枚x10秒、1枚x20秒<br/>
          3. PKプレゼンテーションを作成し、＃ipk2021のタグを付けて事前に投稿してください! 投稿頂いた中から、いくつかをイベント当日にご紹介します。<Link to="/pkcreate">PK Presentation作成はこちらから!</Link><br/>
          4. <strong>PechaKucha Night都市のイベントに参加！</strong>- プレゼンターとして、お近くのPechaKucha Night都市のイベントに参加しませんか？ご参加希望の方は、サイト右下のSupportボタンから、参加方法についてお問い合わせください！<br/>
          </p>
          </span>
        },
        create: {
          'en-US': <span>
                            <span style={{ fontWeight: "bold", fontSize: "larger" }}>Create a 10x10 or 20x20 PK - You’ll love it!:</span><br/>
                            <p style={{ marginLeft: "10px" }}>
                            1. Collect 10 great images on something you love<br/>
                            2. CREATE a new presentation on PechaKucha.com, and select the "ipk2021" category<br/>
                            3. Upload your images to your new presentation<br/>
                            4. Record your voice as the slides advance<br/>
                            5. Publish, Share and tag with <strong>#ipk2021</strong>!<br/>
                            6. Congrats! You're celebrating International PechaKucha Day with us!
                            </p>
          </span>,
          'ja-JP': <span>
<span style={{ fontWeight: "bold", fontSize: "larger" }}>PechaKuchaプレゼンテーション(20x20、10x10、1x20)の作り方</span><br/>
<p style={{ marginLeft: "10px" }}>
1. まず、あなたの’LOVE’なモノ・事についての画像を準備！<br/>
2. PechaKucha.comプラットフォームの’CREATE’からプレゼンテーション投稿！カテゴリーは、 "ipk2021"を選択！<br/>
3. ‘New Presentation’へ画像をアップロード<br/>
4. プレゼンテーション音声の録音<br/>
5. Publish & Shareをして、#ipk2021をタグ付けしてください！<br/>
6. お疲れ様でした！これで、International PechaKucha Dayへの参加完了です！<br/>
</p>
          </span>
        },
        create_button: {
          'en-US': 'Create Your #ipk2021 Presentation',
          'ja-JP': '#ipk2021プレゼンテーション作成'
        },
        what_this_means: {
          'en-US': <span>
                            <span style={{ fontWeight: "bold", fontSize: "larger" }}>What this means to us</span><br/>
                            <ul>
                            <li>Kick off the PechaKucha year with positivity and LOVE!</li>
                            <li>Continue to build the amazing community and connections that are PechaKucha.</li>
                            <li>Encourage you all to try the PechaKucha CREATE platform to make and submit presentations.</li>
                            <li>Most importantly to celebrate LOVE and CREATIVITY from around the world! </li>
                            </ul>
                            <br/>
          </span>,
          'ja-JP': <span></span>
        },
        download_logos: {
          'en-us': <span>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>Download the #ipk2021 logos <a target="_blank" rel="noopener noreferrer" href={download_ipk_images_link}>here</a>:</span><br/>
          </span>,
          'ja-JP': <span>
            <span style={{ fontWeight: "bold", fontSize: "larger" }}>#ipk2021 ロゴのダウンロードは<a target="_blank" rel="noopener noreferrer" href={download_ipk_images_link}>こちら</a>から: </span><br/>
          </span>
        },
        join_us: {
          'en-US': <span>
                          <span style={{ fontWeight: "bold", fontSize: "larger" }}>We hope you will join us</span><br/>
                          It's going to be a LOVE filled 24 hours of connections and fun!
          </span>,
          'ja-JP': <span>
<span style={{ fontWeight: "bold", fontSize: "larger" }}>皆さんのご参加を楽しみにしています！</span><br/>
LOVEに溢れた24時間の世界との繋がりと楽しい時間をぜひ体験してください！
          </span>
        }
      };
      
      
    }
    componentDidMount() {
      console.log("InternationalPk2021 componentDidMount");
      /*
      const language_abbreviation_raw = decodeURIComponent(getQueryString('lang'));
      // make last part uppercase
      if (language_abbreviation_raw && language_abbreviation_raw.indexOf('-') >= 0) {
        let [first_part,make_upper] = language_abbreviation_raw.split('-');
        let language_abbreviation = first_part+'-'+make_upper.toUpperCase();
        console.log(" language_abbreviation",language_abbreviation,this.supported_language_abbreviations.has(language_abbreviation));
        if (language_abbreviation && this.supported_language_abbreviations.has(language_abbreviation)) {
          console.log(" Setting language_abbreviation",language_abbreviation);
          this.context.setLanguage(language_abbreviation);
        }
      }
      */
    }
    componentDidUpdate() {
      console.log("InternationalPk2021 componentDidUpdate");
    }
    render() {
        if (!this.context.user_info) {
          return (
              <FullPageSpinner />
          );
        }        
        
        return (
            <React.Fragment>
                <Helmet defer={false}>
                    <title>International PechaKucha Day - February 20, 2021</title>
                    <meta name="description" content="One Day, Hundreds of Events, Thousands of PechaKucha Presentations" />
                    <meta property="og:image" content={`https://www.pechakucha.com${eventBanner}`} />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://www.pechakucha.com/internationalpk" />
                    <meta property="og:title" content="International PechaKucha Day - February 20, 2021" />
                    <meta property="og:description" content="One Day, Hundreds of Events, Thousands of PechaKucha Presentations" />
                </Helmet>
                <div>
                    {/* Banner Starts */}
                    <div style={{ marginTop: "5px" }}>
                        <a target="_blank" rel="noopener noreferrer" href={signup_link}>
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${eventBanner})` }}>
                            <div className="container">
                            </div>
                        </section>
                        </a>
                    </div>
                    <div className="container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">
                        {/* <p dangerouslySetInnerHTML={{ __html: danger1 }} /> */}
                        <h1 className="null">International PechaKucha Day!&nbsp;</h1>

                        <br />

                        {this.pageText.intro[this.context.language_abbreviation]}
                        {/*                        
                        February 20th is PechaKucha’s birthday and our first big initiative of the year: <strong>International PechaKucha Day 2021</strong> - a record-setting, 24-hour, online-around-the-world event, with PechaKucha Cities participating in all 24 time zones, each broadcasting their local creativity to the world!
                        We invite you to join this special global event! <strong>#ipk2021</strong>!
                        */}


                        <br/>
                        <center>
                        {/*
                          <a target="_blank" rel="noopener noreferrer" href={signup_link}>
                          <Button
                            variant="danger"
                            style={{ borderRadius: "24px", marginTop: "10px", marginBottom: "10px" }}
                            size="lg"
                          >
                            {this.pageText.signup_now_button[this.context.language_abbreviation]}
                          </Button>
                          </a>
                        */}
                          <Link to='/pkmaker' style={{ marginLeft: "10px" }}>
                          <Button
                            variant="danger"
                            style={{ borderRadius: "24px", marginTop: "10px", marginBottom: "10px" }}
                            size="lg"
                          >
                            {this.pageText.pkmaker_button[this.context.language_abbreviation]}
                          </Button>
                          </Link>
                        </center>
                        {this.pageText.theme_love[this.context.language_abbreviation]}
                        
                        {/*
                        <span style={{ fontWeight: "bold", fontSize: "larger" }}>Theme: LOVE</span><br/>
                        We all agree, wherever you are, what the world needs now is <span style={{ color: "red" }}>LOVE</span>!<br/>

                        Even in these tough times, there is still much to LOVE in the world.
                        So for this year's International PechaKucha Day, we’ll be traveling around the world, hearing from lovely presenters in our global network of 1256 cities.
                        We’re also inviting ANYONE to make 20x 20 or a 10x10 PK on PechaKucha.com, share on things they LOVE, and we’ll play some of the best throughout the 24-hour broadcast.
                        Everyone can participate!
                        */}
                      </div>
                    </div>
                    <div style={{ marginTop: "5px" }}>
                        <a target="_blank" rel="noopener noreferrer" href={signup_link}>
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${tellUsWhatYouLoveImg})` }}>
                            <div className="container">
                            </div>
                        </section>
                        </a>
                    </div>
                    <div className="container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">
                        {this.pageText.when_where[this.context.language_abbreviation]}
                        {/*
                        <span style={{ fontWeight: "bold", fontSize: "larger" }}>When:</span><br/>
                        20th February - PechaKucha's Birthday! It’s a Saturday so we hope you will tune in for any or all of the 24-Live Stream!<br/>
                        <br/>
                        <span style={{ fontWeight: "bold", fontSize: "larger" }}>Where:</span><br/>
                        We're connecting via Zoom with PechaKucha City organizers from around the world, who will each curate a few presenters for their local time zone.
                        We'll broadcast all the presentations to the world via Webinar and Youtube starting at 12 noon Tokyo on 20th February and finishing at 12 noon the following day.<br/>
                        */}
                      </div>
                    </div>
                    <Container>
                      <a target="_blank" rel="noopener noreferrer" href={signup_link}>
                      <Row>
                        <Col xs="12" lg="6">
                          <Image src={timetable_1} fluid={true}/>
                        </Col>
                        <Col xs="12" lg="6">
                          <Image src={timetable_2} fluid={true}/>
                        </Col>
                      </Row>
                      </a>
                    </Container>
                    {/*
                    <div style={{ marginTop: "5px" }}>
                        <a target="_blank" rel="noopener noreferrer" href={signup_link}>
                        <Image src={timetable_1} fluid={true}/>
                        <Image src={timetable_2} fluid={true}/>
                        
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${ipkMapImg})` }}>
                            <div className="container">
                            </div>
                        </section>
                       
                        </a>
                    </div>                        
                    */}
                    <div className="container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">
                        {this.pageText.participate[this.context.language_abbreviation]}
                        {/*
                        <span style={{ fontWeight: "bold", fontSize: "larger" }}>How to participate:</span><br/>
                        <p style={{ marginLeft: "10px" }}>
                        1. <strong>Register NOW</strong> for the Zoom Webinar and tune in anytime to the #ipk2020 Livestream on Feb 20th.<br/>
                        2. <strong>Create a 20x20 or 10x10 PK</strong> presentation and tag it with <strong>#ipk2021</strong>.
                        We'll feature some of the best throughout the Livestream! <Link to="/pkcreate">Start PK Creating NOW!</Link><br/>
                        3. <strong>Reach out</strong> to your local PechaKucha organizer and nominate yourself to be a presenter.
                        We can help connect you too! Contact us using the handy 'Support' button in the lower right of your screen.<br/>
                        </p>
                        */}
                        <center>
                        {/*
                          <a target="_blank" rel="noopener noreferrer" href={signup_link}>
                          <Button
                            variant="danger"
                            style={{ borderRadius: "24px", marginTop: "10px", marginBottom: "10px" }}
                            size="lg"
                          >
                            {this.pageText.signup_now_button[this.context.language_abbreviation]}
                          </Button>
                          </a>
                          */}
                          <Link to='/pkmaker' style={{ marginLeft: "10px" }}>
                          <Button
                            variant="danger"
                            style={{ borderRadius: "24px", marginTop: "10px", marginBottom: "10px" }}
                            size="lg"
                          >
                            {this.pageText.pkmaker_button[this.context.language_abbreviation]}
                          </Button>
                          </Link>
                        </center>
                      </div>
                    </div>
                    <div style={{ marginTop: "5px" }}>
                        <Link to="/pkcreate">
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${storytellingMadeEasyImg})` }}>
                            <div className="container">
                            </div>
                        </section>
                        </Link>
                    </div>               
                    <div className="container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">
                            {this.pageText.create[this.context.language_abbreviation]}
                            {/*
                            <span style={{ fontWeight: "bold", fontSize: "larger" }}>Create a 10x10 or 20x20 PK - You’ll love it!:</span><br/>
                            <p style={{ marginLeft: "10px" }}>
                            1. Collect 10 great images on something you love<br />
                            2. CREATE a new presentation on PechaKucha.com, and select the "ipk2021" category<br/>
                            3. Upload your images to your new presentation<br />
                            4. Record your voice as the slides advance<br />
                            5. Publish, Share and tag with <strong>#ipk2021</strong>!<br />
                            6. Congrats! You're celebrating International PechaKucha Day with us!
                            </p>
                            */}
                            <br/>
                            <center>
                              <Link to="/pkcreate">
                              <Button
                                variant="danger"
                                style={{ borderRadius: "24px", marginTop: "10px", marginBottom: "10px" }}
                                size="lg"
                              >
                                {this.pageText.create_button[this.context.language_abbreviation]}
                              </Button>
                              </Link>
                            </center>

                            {this.pageText.what_this_means[this.context.language_abbreviation]}
                            {/*
                            <span style={{ fontWeight: "bold", fontSize: "larger" }}>What this means to us</span><br/>
                            <ul>
                            <li>Kick off the PechaKucha year with positivity and LOVE!</li>
                            <li>Continue to build the amazing community and connections that are PechaKucha.</li>
                            <li>Encourage you all to try the PechaKucha CREATE platform to make and submit presentations.</li>
                            <li>Most importantly to celebrate LOVE and CREATIVITY from around the world! </li>
                            </ul>
                            <br/>
                            */}
                            
                            {this.pageText.download_logos[this.context.language_abbreviation]}
                            {/*
                            <span style={{ fontWeight: "bold", fontSize: "larger" }}>Download the #ipk2021 logos <a target="_blank" rel="noopener noreferrer" href={download_ipk_images_link}>here</a>:</span><br/>
                            */}
                        </div>
                    </div>
                    <div style={{ marginTop: "5px" }}>
                        <a target="_blank" rel="noopener noreferrer" href={download_ipk_images_link}>
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${ipkLoveImg})` }}>
                            <div className="container">
                            </div>
                        </section>
                        </a>
                    </div>                              
                    <div className="container">
                      <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">
                        <center>
                          {this.pageText.join_us[this.context.language_abbreviation]}
                          {/*
                          <span style={{ fontWeight: "bold", fontSize: "larger" }}>We hope you will join us</span><br/>
                          It's going to be a LOVE filled 24 hours of connections and fun!
                          */}
                        </center>
                      </div>
                    </div>


                    {/* Way to Participate Section Ends */}
                    
                    {/* Form Section */}
                    {/*
                    <hr/>
                    <section id="getMoreInfoData" className="p-t0">
                        <div className="container">
                            <Row>
                                <Col lg={12}>
                                    <div className="form-head">
                                        <h1>Share the Love - Be a part of the PechaKucha community!</h1>
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div>
                                        <div className="school-formdetails">

                                            <ReactTypeformEmbed
                                              style={{height: "500px"}}
                                              url="https://pechakucha.typeform.com/to/k3ZcKPWV"
                                            />
                                            
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </section>
                    */}
                    {/* Form Section Ends */}
    
                    <Footer
                      homeImg={home}
                      homeImgRef="/"
                      breadcrumbSubPage="International Pk"
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default InternationalPk;
